/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import md5 from "blueimp-md5";

import { store } from "store";
import { ActionCreators } from "actions";
import { PRIMARY_JOIN_ORG } from "graphql/internal/Mutations";

import { SkalePrimaryApolloClient } from "config/UpduoApolloClient";
import { asyncCallApi } from "config/UpduoService";
import * as UpduoAnalytics from "config/UpduoAnalytics";

export async function login(
  email: string,
  password: string,
  _handleLoginReset,
  orgCode = ""
) {
  const client = `web_${md5(window.navigator.appVersion)}`;
  const response = await asyncCallApi("postLogin", {
    email,
    password,
    client,
  });
  const responseJson = await response?.json();
  await asyncLoginWithKey(responseJson.key, _handleLoginReset, orgCode);
}

export async function loginWithKey(
  key: string,
  failureCallback: (error) => void,
  orgCode?: string
) {
  try {
    return await asyncLoginWithKey(key, failureCallback, orgCode);
  } catch (error) {
    failureCallback(error);
  }
}

export async function asyncLoginWithKey(
  key: string,
  failureCallback: (error) => void,
  orgCode?: string
) {
  try {
    store.dispatch(ActionCreators.setPrimaryAuthToken(key));
    if (orgCode) {
      const { data: primaryJoinOrgData } =
        await SkalePrimaryApolloClient.mutate({
          mutation: PRIMARY_JOIN_ORG,
          variables: {
            primaryJoinOrgRequest: {
              orgCode,
            },
          },
        });
      if (!primaryJoinOrgData?.ok && primaryJoinOrgData?.reason) {
        UpduoAnalytics.logEvent("app-joinorganization-primaryjoinorg-error", {
          error: primaryJoinOrgData.reason,
        });
        console.error("ERROR primaryJoinOrg", primaryJoinOrgData.reason);
      }
    }
  } catch (error) {
    failureCallback(error);
  }
}
